// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

export class AntiForgeryUtility {
    static GetForgeryToken(): string {
        return {
            //"__RequestVerificationToken": $('input[name=__OITAntiforgeryField]').val()
            "__OITAntiforgeryField": $('input[name=__OITAntiforgeryField]').val()
        }
    }

    static GetForgeryFormToken() : string {
        return "__OITAntiforgeryField=" + $('input[name=__OITAntiforgeryField]').val();
    }

    static SetForgeryFromTokenInHeader() : { [key: string]: string } {
        var headers = {};
        var oitToken = $('input[name=__OITAntiforgeryField]').val()
        headers['X-CSRF-TOKEN-OIT'] = oitToken;
        return headers;
    }

}